module.exports = __webpack_public_path__ + "static/logo-be794eca36ee7e38999e31b908c98ac2.png";